import JobAdContainer from "../../../components/job/other/JobAd";

const JobAd = () => {
  return <JobAdContainer />;
};

export default JobAd;
